import { getLabel } from "./statuses";

const forms = {
    issuers: ["USCIS"],
    categories: ["Immigration"],
    statuses: [
        { value: "open", label: getLabel("open") },
        { value: "draft", label: getLabel("draft") },
        { value: "completed", label: getLabel("completed") },
    ],
};

export default forms;